export const listTimeline = [
  {
    id: 0,
    label: "Associar"
  },
  {
    id: 1,
    label: "Identificar motorista"
  },
  {
    id: 2,
    label: "Identificar veículo e Autorização"
  },
  {
    id: 3,
    label: "Pagamento"
  }
]